import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import ProductionPlantComponent from '../components/production-plant.component';
import { productionPlants } from '../../../../../../redux/production-plants/action';
import { selectProductionPlantsQueryItems } from '../../../../../../redux/production-plants/selector';

const ManagementProductionPlant = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const productionPlantQuery = useSelector(selectProductionPlantsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    selectedProductionPlant,
    setSelectedProductionPlant
  ] = useState<any>([])

  const fetchBranchesQueryById= ()=>{
    dispatch(productionPlants.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants/query`,entity:'productionPlants',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedProductionPlant({ ...selectedProductionPlant, [field]: event })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedProductionPlant({ ...selectedProductionPlant, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  
  useEffect(
    () => {
        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
                fetchBranchesQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedProductionPlant(productionPlantQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: productionPlantQuery?.result?.items?.PrimaryAddress,
            BillingAddress: productionPlantQuery?.result?.items?.BillingAddress,
            ShippingAddress: productionPlantQuery?.result?.items?.ShippingAddress})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const productionPlantData= {
   
        ProductionPlantInfo: {
            Id: selectedProductionPlant?.ProductionPlantInfo?.Id || 0,
            Name: selectedProductionPlant?.ProductionPlantInfo?.Name,
            PhoneNumber: selectedProductionPlant?.ProductionPlantInfo?.PhoneNumber,
            IsPrimaryProductionPlant: selectedProductionPlant?.ProductionPlantInfo?.IsPrimaryProductionPlant,
            OrganizationUnitId: selectedProductionPlant?.ProductionPlantInfo?.OrganizationUnitId
          },
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedProductionPlant?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedProductionPlant?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
      if (parmas?.id > 0) {
     dispatch(productionPlants.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants`,entity:'productionPlants',jsonData:{
          
    Records: [
        productionPlantData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(productionPlants.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants`,entity:'productionPlants',jsonData:{
            
        Records: [
            productionPlantData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/production-plants')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <ProductionPlantComponent 
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          back={back}
          handleFormSubmit ={handleFormSubmit}
          onInnerFormChange ={handleInnerFormChange}
          organizationUnits={organizationUnitsItems?.result?.items}
          selectedAddress ={selectedAddress}
          selectedProductionPlant={selectedProductionPlant}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementProductionPlant;